import { render, staticRenderFns } from "./vnp-keyboard.vue?vue&type=template&id=a1c0180e&scoped=true&"
import script from "./vnp-keyboard.vue?vue&type=script&lang=js&"
export * from "./vnp-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./vnp-keyboard.vue?vue&type=style&index=0&id=a1c0180e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0180e",
  null
  
)

export default component.exports